// Investor bank-accounts directory endpoint functions.
//
// Endpoints accept camelCase view-model inputs and return camelCase
// view-model outputs. Snake_case lives ONLY between the network and
// the parser.

import { adminApi } from '@core/api/httpClient'
import { BANK_ACCOUNTS_DIRECTORY_ENDPOINT_PATHS } from './bankAccountsDirectoryEndpointPaths'
import type { BankAccountListResponseDto } from './bankAccountsDirectoryContracts'
import type {
  BankAccountsDirectoryListResponse,
  GetBankAccountsDirectoryParams,
} from '../types/bankAccountsDirectoryTypes'
import { parseBankAccountsDirectoryListResponse } from './bankAccountsDirectoryParser'

type WireListResponse = BankAccountListResponseDto | { data: BankAccountListResponseDto }

function unwrap<T>(payload: T | { data: T }): T {
  if (payload && typeof payload === 'object' && 'data' in payload) {
    return (payload as { data: T }).data
  }
  return payload as T
}

export async function getBankAccountsDirectory(
  params: GetBankAccountsDirectoryParams,
): Promise<BankAccountsDirectoryListResponse> {
  const queryParams: Record<string, string> = {}
  if (params.page) queryParams.page = String(params.page)
  if (params.limit) queryParams.limit = String(params.limit)
  if (params.investorId) queryParams.investorId = params.investorId
  if (params.firstName) queryParams.firstName = params.firstName
  if (params.lastName) queryParams.lastName = params.lastName
  if (params.investorEmail) queryParams.investorEmail = params.investorEmail
  if (params.bankName) queryParams.bankName = params.bankName
  if (params.accountStatus) queryParams.accountStatus = params.accountStatus
  if (params.currencyCode) queryParams.currencyCode = params.currencyCode

  const { data } = await adminApi.get<WireListResponse>(
    BANK_ACCOUNTS_DIRECTORY_ENDPOINT_PATHS.LIST,
    { params: queryParams },
  )
  return parseBankAccountsDirectoryListResponse(unwrap(data))
}
